import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IAuthentication_Forgot_PasswordVerificationCode_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAuthentication_Forgot_PasswordVerificationCode_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  IsVerificationCodeValid: boolean;
  IsVerificationCodeValid_dummy: boolean;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
}

export class Authentication_Forgot_PasswordVerificationCode_ScreenBase extends React.PureComponent<
  IAuthentication_Forgot_PasswordVerificationCode_ScreenProps,
  any
> {
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "e19bc33f-a90d-4b45-8129-45780139e836",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 695885, PropertyName: "value", Value: "Verify Your Email" },
        {
          Id: 722774,
          PropertyName: "value",
          Value: "Please enter your verification code",
        },
        {
          Id: 846142,
          PropertyName: "value",
          Value: "Enter the verification code sent to your email address.",
        },
        {
          Id: 138256,
          PropertyName: "placeholder",
          Value: "Enter verification code here",
        },
        { Id: 854781, PropertyName: "label", Value: "Verify Email" },
        { Id: 384658, PropertyName: "value", Value: "Return to" },
        { Id: 28660, PropertyName: "value", Value: "Sign In" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      IsVerificationCodeValid: false,
      NAVIGATE: "",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "authentication_forgot_passwordverificationcode",
        ""
      );
      return;
    }

    this.fillFormInitValues();
    if (true) {
    }

    window.addEventListener("keydown", this.onKeyDown);

    KuikaAppManager.calculateAndSetBodyHeight(
      "authentication_forgot_passwordverificationcode",
      ""
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyDown);

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  onKeyDown = (e: any) => {
    if (e.keyCode === undefined) return;
    if (e.repeat) return;

    const keyCode = e.keyCode;
    if (keyCode === 13) {
      e.stopPropagation();
      var element = document.getElementById("854781");
      if (element && element.click) {
        element.click();
      }
    }
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "authentication_forgot_passwordverificationcode",
      ""
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      authentication_forgot_passwordverificationcode_138256_value: undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  Authentication_Forgot_PasswordVerificationCodeComponent_854781_onClick =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      validations.push({
        isValid: ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.value(
            this,
            "authentication_forgot_passwordverificationcode_138256_value",
            "value",
            "",
            "",
            ""
          ),
          null
        ),
        message: "This field is required",
        formName: "authentication_forgot_passwordverificationcode_138256_value",
        condition: true,
      } as IValidationData);

      validations.forEach((validation) => {
        if (validation.message === "Geçerli bir mail adresi giriniz.") {
          validation.message = ReactSystemFunctions.getEmailValidationMessage();
        }
      });

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }
      KuikaAppManager.showSpinner(this);
      KuikaAppManager.increaseServerRequestCount();

      stateVars.IsVerificationCodeValid =
        await ReactSystemFunctions.isVerificationCodeValid(
          this,
          ReactSystemFunctions.toString(
            this,
            ReactSystemFunctions.value(
              this,
              "authentication_forgot_passwordverificationcode_138256_value",
              "value",
              "",
              "",
              ""
            )
          )
        );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);

      return isErrorOccurred;
    };

  Authentication_Forgot_PasswordVerificationCodeComponent_28660_onClick =
    async () => {
      let stateVars = {} as any;
      let formVars = {} as any;
      let validations = [] as IValidationData[];
      let isErrorOccurred = false;

      if (KuikaAppManager.handleValidations(this, validations)) {
        const invalidValidation = validations.find(
          (v) => !v.isValid && v.condition
        );
        if (invalidValidation) {
          const formName = invalidValidation?.formName;
          const fieldId = formName?.match(/\d+/)?.[0];
          if (!formName || !fieldId) return;

          const applyError = () =>
            this.props.form?.setFields([
              {
                name: formName,
                errors: [invalidValidation.message],
                touched: true,
              },
            ]);

          applyError();
        }
        return true;
      }
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "Authentication_Forgot_PasswordVerificationCode",
        "Signin",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);

      return isErrorOccurred;
    };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
  }
}
